import {
  TableCellProps,
  WbLink,
  WbTruncatedTypographyWrapper,
  useTruncatedStyles,
} from '@agilelab/plugin-wb-platform';

import { useRouteRef } from '@mainstage/core-plugin-api';
import { Typography } from '@material-ui/core';
import { dataProductRouteRef, outputPortRouteRef } from '../../../../routes';
import { SemanticLinkingVM } from '../SemanticLinkingTable';

export function useSemanticLinkingTableColumnSpecs(): Array<
  TableCellProps<SemanticLinkingVM>
> {
  const truncatedClass = useTruncatedStyles({});
  const dataProductRoute = useRouteRef(dataProductRouteRef);
  const outputPortRoute = useRouteRef(outputPortRouteRef);

  return [
    {
      field: 'domain',
      headerName: 'domain',
      fieldRender: field => (
        <WbTruncatedTypographyWrapper value={field.domain || '-'} />
      ),
    },
    {
      field: 'projectName',
      headerName: 'System',
      fieldRender: field =>
        field.dataProductInstanceId ? (
          <WbLink
            to={dataProductRoute({
              id: field.dataProductInstanceId,
            })}
          >
            <WbTruncatedTypographyWrapper value={field.projectName ?? '-'} />
          </WbLink>
        ) : (
          <Typography>_</Typography>
        ),
    },
    {
      field: 'displayName',
      headerName: 'Component',
      fieldRender: field =>
        field.referenceId ? (
          <WbLink to={outputPortRoute({ id: field.referenceId })}>
            <WbTruncatedTypographyWrapper value={field.displayName ?? ''} />
          </WbLink>
        ) : (
          <WbTruncatedTypographyWrapper value={field.referenceOutputPort} />
        ),
    },
    {
      field: 'referenceFieldName',
      tooltip: true,
      typographyProps: {
        component: 'p',
        className: truncatedClass.truncated,
      },
      headerName: 'name',
    },
  ];
}
